var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "bg-green-gray px-3 py-2 rounded-top border-bottom" },
        [
          _c("medical-plan-badges", {
            attrs: {
              "has-consent": _vm.value.hasConsent,
              "has-medical-plan": _vm.value.hasMedicalPlan
            }
          })
        ],
        1
      ),
      _c(
        "custom-callout",
        {
          attrs: { controlled: "", "has-toggle": "", opened: _vm.value.opened },
          on: {
            "click:open": function($event) {
              return _vm.toggle()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c("div", { staticClass: "bg-secondary-3 p-2" }, [
                    _vm.isAdditionalInfo
                      ? _c(
                          "div",
                          { staticClass: "bg-white p-3 rounded mr-0 ml-0" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12 mb-3" }, [
                                _c("i", {
                                  staticClass: "fas fa-info-circle text-orange"
                                }),
                                _c("b", { staticClass: "ml-2" }, [
                                  _vm._v(" Información Adicional ")
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-md" }, [
                                _c("div", { staticClass: "data-name" }, [
                                  _vm._v("Tipo de Lugar:")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.value.locationType?.name
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-md" }, [
                                _c("div", { staticClass: "data-name" }, [
                                  _vm._v("Modalidad:")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.value.modalityType?.name
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-md" }, [
                                _c("div", { staticClass: "data-name" }, [
                                  _vm._v("Frecuencia:")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.value.frequencyType?.name
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "col-12 col-md" }, [
                                _c("div", { staticClass: "data-name" }, [
                                  _vm._v("Duración:")
                                ]),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("empty")(
                                        _vm.value.therapyDuration?.name
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { staticClass: "row d-flex align-items-center py-2 pr-3" },
            [
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Estudiante:")
                ]),
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.value.student?.id)) +
                      " - " +
                      _vm._s(_vm._f("empty")(_vm.value.student?.name)) +
                      " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Servicio:")]),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm._f("empty")(_vm.value.disciplineType?.name))
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Lugar de Servicio:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.location?.name)))
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-12 col-md-2 d-flex justify-content-end" },
                [_c("drop-down", { attrs: { items: _vm.actions } })],
                1
              ),
              _c("div", { staticClass: "w-100 px-3" }, [_c("hr")]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Cantidad de Servicios:")
                ]),
                _c("div", [_vm._v(_vm._s(_vm.value.serviceCount))])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Proveedor:")]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.company?.name)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Especialista:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.specialist?.name)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md-2" })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }